import { Link } from 'react-router';

import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { Typography } from 'Components/Typography';

const StyledTypography = styled(Typography)({
  width: '100%',
  padding: '53px 24px',
  backgroundColor: theme.colors.tertiary[200],
});

const LegalsBlock = () => (
  <StyledTypography align="center" variant="p1">
    By becoming a member, you agree to our <Link to="/terms/subscription">terms & conditions</Link>.
  </StyledTypography>
);

export default LegalsBlock;
